export enum ChangeEmailTranslations {
  title = 'changeemailsettings.title',
  titleChangeEmail = 'changeemailsettings.titleChangeEmail',
  newEmailAddress = 'changeemailsettings.newEmailAddress',
  typeNewAddress = 'changeemailsettings.typeNewAddress',
  cancel = 'changeemailsettings.cancel',
  saveChanges = 'changeemailsettings.saveChanges',
  successMessage = 'changeemailsettings.successMessage',
}
